var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXNegative = function SvgXNegative(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    overflow: "visible",
    viewBox: "0 0 60 60",
    xmlSpace: "preserve"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M16.1 16.1c1.5-1.5 3.8-1.5 5.3 0l8.6 8.6 8.6-8.6c1.5-1.5 3.8-1.5 5.3 0s1.5 3.8 0 5.3L35.3 30l8.6 8.6c1.5 1.5 1.5 3.8 0 5.3s-3.8 1.5-5.3 0L30 35.3l-8.6 8.6c-1.5 1.5-3.8 1.5-5.3 0s-1.5-3.8 0-5.3l8.6-8.6-8.6-8.6c-1.5-1.5-1.5-3.8 0-5.3z"
  })));
};
export default SvgXNegative;